import MatchEvent from '../../../interfaces/matchEvent';
import { MatchEventType } from '../../../enums/matchEventType';

export default function (matchEvent: MatchEvent): boolean {
  return [
    MatchEventType.GOAL,
    MatchEventType.OWN_GOAL,
    MatchEventType.PLAYER_OFF,
    MatchEventType.PENALTY,
    MatchEventType.PENALTY_MISS,
  ].includes(matchEvent.matchEventTypeId);
}
